import { ref, openBlock, createElementBlock, withModifiers, createCommentVNode, normalizeClass, createElementVNode, toDisplayString, createBlock, renderSlot, getCurrentInstance, computed, onMounted, watch, withDirectives, vModelCheckbox, pushScopeId, popScopeId, watchEffect, onUnmounted, Fragment, renderList, unref, vModelText, resolveComponent, withKeys, vModelDynamic, createTextVNode, normalizeStyle, createVNode } from "vue";
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var tinyEmitter = { exports: {} };
function E$1() {
}
E$1.prototype = {
  on: function(name, callback, ctx) {
    var e = this.e || (this.e = {});
    (e[name] || (e[name] = [])).push({
      fn: callback,
      ctx
    });
    return this;
  },
  once: function(name, callback, ctx) {
    var self = this;
    function listener() {
      self.off(name, listener);
      callback.apply(ctx, arguments);
    }
    listener._ = callback;
    return this.on(name, listener, ctx);
  },
  emit: function(name) {
    var data = [].slice.call(arguments, 1);
    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
    var i = 0;
    var len = evtArr.length;
    for (i; i < len; i++) {
      evtArr[i].fn.apply(evtArr[i].ctx, data);
    }
    return this;
  },
  off: function(name, callback) {
    var e = this.e || (this.e = {});
    var evts = e[name];
    var liveEvents = [];
    if (evts && callback) {
      for (var i = 0, len = evts.length; i < len; i++) {
        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
          liveEvents.push(evts[i]);
      }
    }
    liveEvents.length ? e[name] = liveEvents : delete e[name];
    return this;
  }
};
tinyEmitter.exports = E$1;
tinyEmitter.exports.TinyEmitter = E$1;
var tinyEmitterExports = tinyEmitter.exports;
var E = tinyEmitterExports;
var instance = new E();
const messageBus = /* @__PURE__ */ getDefaultExportFromCjs(instance);
const Tooltip_vue_vue_type_style_index_0_scoped_19025866_lang = "";
const _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
const _sfc_main$i = {
  name: "Tooltip",
  props: ["content", "right-aligned"],
  data() {
    return {
      isVisible: false,
      actualContent: ""
    };
  },
  computed: {
    tooltipContent() {
    }
  },
  setup() {
    const toolEl = ref(null);
    return { toolEl };
  },
  mounted() {
    document.addEventListener("click", this.onClickOutside);
    document.addEventListener("touchstart", this.onClickOutside);
    messageBus.on("tooltip-displayed", (sender) => {
      if (sender !== this)
        this.isVisible = false;
    });
  },
  destroyed() {
    document.removeEventListener("click", this.onClickOutside);
    document.removeEventListener("touchstart", this.onClickOutside);
    messageBus.off("tooltip-displayed");
  },
  methods: {
    toggleTooltip() {
      this.isVisible = !this.isVisible;
      if (this.isVisible) {
        messageBus.emit("tooltip-displayed", this);
        this.$nextTick(() => {
          let element = this.toolEl.querySelector(".content");
          let width = element.offsetWidth;
          let viewportWidth = document.body.offsetWidth;
          if (this.$props.rightAligned) {
            element.style.right = "10px";
          } else {
            let left = element.getBoundingClientRect().left;
            if (left + width > viewportWidth) {
              element.style.left = `${viewportWidth - width - left - 16}px`;
            } else {
              element.style.left = "10px";
            }
          }
        });
      }
    },
    onClick(e) {
      e.stopPropagation();
      if (!this.content)
        return;
      if (typeof this.content === "function") {
        this.content().then((res) => {
          this.actualContent = res;
          this.toggleTooltip();
        }).catch((err) => {
          console.error(err.message);
        });
      } else {
        this.actualContent = this.content;
        this.toggleTooltip();
      }
    },
    onClickOutside(e) {
      var _a, _b;
      e.stopPropagation();
      if (!((_b = (_a = this.toolEl) == null ? void 0 : _a.value) == null ? void 0 : _b.contains(e.target))) {
        this.isVisible = false;
      }
    }
  }
};
const _hoisted_1$h = ["innerHTML"];
function _sfc_render$7(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: "tooltip vue-ctrl",
    onClick: _cache[0] || (_cache[0] = withModifiers((...args) => $options.onClick && $options.onClick(...args), ["stop"])),
    ref: "toolEl"
  }, [
    $data.isVisible ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: "content",
      innerHTML: $data.actualContent
    }, null, 8, _hoisted_1$h)) : createCommentVNode("", true)
  ], 512);
}
const Tooltip = /* @__PURE__ */ _export_sfc(_sfc_main$i, [["render", _sfc_render$7], ["__scopeId", "data-v-19025866"]]);
const CheckboxGroup_vue_vue_type_style_index_0_scoped_8783231b_lang = "";
const _hoisted_1$g = { class: "label-container" };
const _hoisted_2$e = {
  key: 0,
  class: "group-label"
};
const _hoisted_3$d = { class: "checkbox-container" };
const _hoisted_4$b = { class: "description-container" };
const _hoisted_5$a = { class: "validation-error" };
const _sfc_main$h = {
  __name: "CheckboxGroup",
  props: [
    "label",
    "mandatory",
    "inline",
    "tooltip",
    "description",
    "validation-message"
  ],
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["cla-checkbox-group vue-ctrl", { mandatory: typeof __props.mandatory !== "undefined" && __props.mandatory !== false, inline: typeof __props.inline !== "undefined" && __props.inline !== false }])
      }, [
        createElementVNode("div", _hoisted_1$g, [
          __props.label ? (openBlock(), createElementBlock("div", _hoisted_2$e, toDisplayString(__props.label), 1)) : createCommentVNode("", true),
          __props.tooltip ? (openBlock(), createBlock(Tooltip, {
            key: 1,
            content: __props.tooltip
          }, null, 8, ["content"])) : createCommentVNode("", true)
        ]),
        createElementVNode("div", _hoisted_3$d, [
          renderSlot(_ctx.$slots, "default", {}, void 0, true)
        ]),
        createElementVNode("div", _hoisted_4$b, toDisplayString(__props.description), 1),
        createElementVNode("div", _hoisted_5$a, toDisplayString(_ctx.validationMessage), 1)
      ], 2);
    };
  }
};
const CheckboxGroup = /* @__PURE__ */ _export_sfc(_sfc_main$h, [["__scopeId", "data-v-8783231b"]]);
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues) {
    getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
    if (!getRandomValues) {
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
  }
  return getRandomValues(rnds8);
}
const byteToHex = [];
for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 256).toString(16).slice(1));
}
function unsafeStringify(arr, offset = 0) {
  return (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + "-" + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + "-" + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + "-" + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + "-" + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase();
}
const randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
const native = {
  randomUUID
};
function v4(options, buf, offset) {
  if (native.randomUUID && !buf && !options) {
    return native.randomUUID();
  }
  options = options || {};
  const rnds = options.random || (options.rng || rng)();
  rnds[6] = rnds[6] & 15 | 64;
  rnds[8] = rnds[8] & 63 | 128;
  if (buf) {
    offset = offset || 0;
    for (let i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }
    return buf;
  }
  return unsafeStringify(rnds);
}
const Utils = {
  getComponentId(component) {
    var _a, _b;
    if (!component)
      return `unknown-component-${v4()}`;
    if (typeof component === "string") {
      return `${component.toLowerCase()}-${v4()}`;
    } else {
      return `${(_b = (_a = component.$options) == null ? void 0 : _a.name) == null ? void 0 : _b.toLowerCase()}-${v4()}`;
    }
  }
};
const Checkbox_vue_vue_type_style_index_0_scoped_ad0667dd_lang = "";
const _withScopeId$2 = (n) => (pushScopeId("data-v-ad0667dd"), n = n(), popScopeId(), n);
const _hoisted_1$f = ["id", "checked", "name", "value"];
const _hoisted_2$d = /* @__PURE__ */ _withScopeId$2(() => /* @__PURE__ */ createElementVNode("div", { class: "checkmark" }, null, -1));
const _hoisted_3$c = ["for"];
const _sfc_main$g = {
  __name: "Checkbox",
  props: ["id", "name", "label", "checked", "modelValue", "tooltip", "invalid", "value"],
  emits: ["update:modelValue", "change"],
  setup(__props, { emit }) {
    const props = __props;
    const self = getCurrentInstance();
    const isChecked = ref(false);
    const uniqueId = computed({
      get() {
        return Utils.getComponentId(self == null ? void 0 : self.type.__name);
      }
    });
    function onClick(e) {
      e.preventDefault();
      isChecked.value = !isChecked.value;
      emit("update:modelValue", isChecked.value);
      emit("change", { sender: props, checked: isChecked.value });
    }
    onMounted(() => {
      isChecked.value = props.checked ? true : false;
    });
    watch(props, () => {
      isChecked.value = props.modelValue ? true : false;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("a", {
        class: normalizeClass(["cla-checkbox vue-ctrl", { invalid: typeof __props.invalid !== "undefined" && __props.invalid !== false }]),
        onClick
      }, [
        withDirectives(createElementVNode("input", {
          type: "checkbox",
          id: uniqueId.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isChecked.value = $event),
          checked: isChecked.value,
          name: __props.name,
          value: __props.value
        }, null, 8, _hoisted_1$f), [
          [vModelCheckbox, isChecked.value]
        ]),
        _hoisted_2$d,
        createElementVNode("label", {
          for: uniqueId.value,
          class: "checklabel"
        }, toDisplayString(__props.label), 9, _hoisted_3$c),
        __props.tooltip ? (openBlock(), createBlock(Tooltip, {
          key: 0,
          content: __props.tooltip
        }, null, 8, ["content"])) : createCommentVNode("", true)
      ], 2);
    };
  }
};
const Checkbox = /* @__PURE__ */ _export_sfc(_sfc_main$g, [["__scopeId", "data-v-ad0667dd"]]);
const RadioButtonGroup_vue_vue_type_style_index_0_scoped_7dd248ed_lang = "";
const _hoisted_1$e = { class: "label-container" };
const _hoisted_2$c = {
  key: 0,
  class: "group-label"
};
const _hoisted_3$b = { class: "radio-container" };
const _hoisted_4$a = { class: "description-container" };
const _hoisted_5$9 = { class: "validation-error" };
const _sfc_main$f = {
  __name: "RadioButtonGroup",
  props: [
    "label",
    "mandatory",
    "inline",
    "name",
    "tooltip",
    "description",
    "validation-message"
  ],
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["cla-radio-group vue-ctrl", { mandatory: typeof __props.mandatory !== "undefined" && __props.mandatory !== false, inline: typeof __props.inline !== "undefined" && __props.inline !== false }])
      }, [
        createElementVNode("div", _hoisted_1$e, [
          __props.label ? (openBlock(), createElementBlock("div", _hoisted_2$c, toDisplayString(__props.label), 1)) : createCommentVNode("", true),
          __props.tooltip ? (openBlock(), createBlock(Tooltip, {
            key: 1,
            content: __props.tooltip
          }, null, 8, ["content"])) : createCommentVNode("", true)
        ]),
        createElementVNode("div", _hoisted_3$b, [
          renderSlot(_ctx.$slots, "default", {}, void 0, true)
        ]),
        createElementVNode("div", _hoisted_4$a, toDisplayString(__props.description), 1),
        createElementVNode("div", _hoisted_5$9, toDisplayString(_ctx.validationMessage), 1)
      ], 2);
    };
  }
};
const RadioButtonGroup = /* @__PURE__ */ _export_sfc(_sfc_main$f, [["__scopeId", "data-v-7dd248ed"]]);
const RadioButton_vue_vue_type_style_index_0_scoped_635e9fbb_lang = "";
const _withScopeId$1 = (n) => (pushScopeId("data-v-635e9fbb"), n = n(), popScopeId(), n);
const _hoisted_1$d = ["id", "name", "value", "checked"];
const _hoisted_2$b = /* @__PURE__ */ _withScopeId$1(() => /* @__PURE__ */ createElementVNode("div", { class: "radiomark" }, null, -1));
const _hoisted_3$a = ["for"];
const _sfc_main$e = {
  __name: "RadioButton",
  props: ["id", "name", "label", "value", "tooltip", "modelValue"],
  emits: ["update:modelValue", "change"],
  setup(__props, { emit }) {
    const props = __props;
    const self = getCurrentInstance();
    const isChecked = ref(false);
    const uniqueId = computed({
      get() {
        return Utils.getComponentId(self == null ? void 0 : self.type.__name);
      }
    });
    function onClick(e) {
      e.preventDefault();
      emit("update:modelValue", props.value);
      emit("change", { sender: props });
    }
    onMounted(() => {
      isChecked.value = props.modelValue === props.value;
    });
    watchEffect(() => {
      isChecked.value = props.modelValue === props.value;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("a", {
        class: "cla-radio vue-ctrl",
        onClick
      }, [
        createElementVNode("input", {
          type: "radio",
          id: uniqueId.value,
          name: __props.name,
          value: __props.value,
          checked: isChecked.value
        }, null, 8, _hoisted_1$d),
        _hoisted_2$b,
        createElementVNode("label", {
          for: uniqueId.value,
          class: "radiolabel"
        }, toDisplayString(__props.label), 9, _hoisted_3$a),
        __props.tooltip ? (openBlock(), createBlock(Tooltip, {
          key: 0,
          content: __props.tooltip
        }, null, 8, ["content"])) : createCommentVNode("", true)
      ]);
    };
  }
};
const RadioButton = /* @__PURE__ */ _export_sfc(_sfc_main$e, [["__scopeId", "data-v-635e9fbb"]]);
const DropList_vue_vue_type_style_index_0_scoped_678acd4a_lang = "";
const _hoisted_1$c = ["id"];
const _hoisted_2$a = ["val"];
const _hoisted_3$9 = { class: "control-container" };
const _hoisted_4$9 = { class: "input-container" };
const _hoisted_5$8 = ["placeholder", "readonly", "aria-label"];
const _hoisted_6$6 = ["for"];
const _hoisted_7$3 = ["val", "onClick"];
const _hoisted_8$2 = { class: "description-container" };
const _hoisted_9$1 = { class: "validation-error" };
const _sfc_main$d = {
  __name: "DropList",
  props: [
    "label",
    "mandatory",
    "filterable",
    "data",
    "modelValue",
    "labels",
    "values",
    "placeholder",
    "tooltip",
    "disabled",
    "invalid",
    "description",
    "validation-message",
    "custom-entry-label",
    "tooltip-right-aligned"
  ],
  emits: ["update:modelValue", "change", "custom"],
  setup(__props, { emit }) {
    const props = __props;
    const labelField = props.labels || "name";
    const valueField = props.values || "id";
    let dropDownVisible = ref(false);
    let highlightedIndex = ref(-1);
    let visibleData = ref([]);
    const self = getCurrentInstance();
    const refDropdown = ref(null);
    const currentSelection = ref("");
    const uniqueId = computed({
      get() {
        return Utils.getComponentId(self == null ? void 0 : self.type.__name);
      }
    });
    watchEffect(() => {
      selectValue(props.modelValue);
      visibleData.value = Array.isArray(props.data) ? [...props.data] : [];
    });
    onMounted(() => {
      visibleData.value = Array.isArray(props.data) ? [...props.data] : [];
      document.addEventListener("click", onClickOutside);
      document.addEventListener("touchstart", onClickOutside);
      messageBus.on("dropdown-displayed", (sender) => {
        if (sender !== self)
          dropDownVisible.value = false;
      });
      if (props.modelValue && props.data) {
        console.log("Setting default selection when mounted.");
        const val = props.modelValue;
        let entry = props.data.find((i) => {
          return i[valueField] === val;
        });
        if (entry) {
          currentSelection.value = entry[labelField];
        } else {
          currentSelection.value = "";
        }
        if (typeof props.filterable !== "undefined" && !props.disabled && props.customEntryLabel) {
          let el = {};
          el[labelField] = props.customEntryLabel;
          el[valueField] = "---custom--entry---";
          visibleData.value.push(el);
        }
      }
    });
    onUnmounted(() => {
      document.removeEventListener("click", onClickOutside);
      document.removeEventListener("touchstart", onClickOutside);
    });
    function toggleDropDown() {
      var _a, _b;
      if (props.disabled)
        return;
      dropDownVisible.value = !dropDownVisible.value;
      if (typeof props.filterable !== "undefined" && dropDownVisible.value) {
        (_b = (_a = refDropdown.value) == null ? void 0 : _a.querySelector("input[type='search']")) == null ? void 0 : _b.focus();
      }
      if (dropDownVisible.value) {
        messageBus.emit("dropdown-displayed", self);
      }
    }
    function selectValue(value) {
      if (!value || !props.data || props.data.length === 0) {
        currentSelection.value = "";
        return;
      }
      let matchingItems = props.data.filter((x) => x[valueField] === value);
      if (matchingItems && matchingItems.length > 0) {
        currentSelection.value = matchingItems[0][labelField];
      }
    }
    function selectItem(item) {
      dropDownVisible.value = false;
      const value = item ? item[valueField] : "";
      const label = item ? item[labelField] : "";
      currentSelection.value = label;
      emit("update:modelValue", value);
      emit("change", {
        sender: self.props,
        value,
        label
      });
      if (item && item[valueField] && item[valueField] === "---custom--entry---") {
        emit("custom", { sender: self.props });
      }
    }
    function onBlur() {
      dropDownVisible.value = false;
    }
    function onClickOutside(e) {
      if (!refDropdown)
        return;
      if (!dropDownVisible.value)
        return;
      if (!refDropdown.value.contains(e.target)) {
        dropDownVisible.value = false;
      }
    }
    function onKeyDown(e) {
      if (typeof props.filterable !== "undefined" && props.filterable === true) {
        if (e.keyCode === 27) {
          e.preventDefault();
          dropDownVisible.value = false;
        } else if (e.keyCode === 9) {
          dropDownVisible.value = false;
        } else {
          dropDownVisible.value = true;
        }
      }
    }
    function onKeyUp(e) {
      if (typeof props.filterable !== "undefined" && props.filterable === true) {
        refDropdown.value.querySelector(".options-container");
        const container = refDropdown.value;
        if (e.keyCode === 40) {
          e.preventDefault();
          if (!dropDownVisible.value) {
            dropDownVisible.value = true;
            messageBus.emit("dropdown-displayed", self);
            highlightedIndex.value = visibleData.value.findIndex((x) => x[labelField] === currentSelection.value);
          } else {
            if (highlightedIndex.value < visibleData.value.length - 1)
              highlightedIndex.value++;
          }
        } else if (e.keyCode === 38) {
          e.preventDefault();
          if (highlightedIndex.value > 0)
            highlightedIndex.value--;
        } else if (e.keyCode === 13) {
          if (highlightedIndex.value > -1 && highlightedIndex.value < visibleData.value.length) {
            selectItem(visibleData.value[highlightedIndex.value]);
          } else {
            selectItem("");
          }
          container.focus();
        } else if (e.keyCode === 27) {
          e.preventDefault();
          dropDownVisible.value = false;
        } else if (isPrintable(e.keyCode) || e.keyCode === 46 || e.keyCode === 8) {
          filterDropDownOptions();
        }
      }
    }
    function filterDropDownOptions() {
      let ss = currentSelection.value.toLowerCase();
      visibleData.value = [];
      props.data.map((e) => {
        if (e[labelField] && e[labelField].toLowerCase().indexOf(ss) !== -1) {
          visibleData.value.push(e);
        }
      });
      highlightedIndex.value = -1;
      if (typeof props.filterable !== "undefined" && !props.disabled && props.customEntryLabel) {
        let el = {};
        el[labelField] = props.customEntryLabel;
        el[valueField] = "---custom--entry---";
        visibleData.value.push(el);
      }
    }
    function isPrintable(keycode) {
      var valid = keycode > 47 && keycode < 58 || // number keys
      keycode == 32 || keycode == 13 || // spacebar & return key(s) (if you want to allow carriage returns)
      keycode > 64 && keycode < 91 || // letter keys
      keycode > 95 && keycode < 112 || // numpad keys
      keycode > 185 && keycode < 193 || // ;=,-./` (in order)
      keycode > 218 && keycode < 223;
      return valid;
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["cla-droplist-container vue-ctrl", {
          mandatory: typeof __props.mandatory !== "undefined" && __props.mandatory !== false,
          invalid: typeof __props.invalid !== "undefined" && __props.invalid !== false
        }]),
        onBlur,
        ref_key: "refDropdown",
        ref: refDropdown
      }, [
        createElementVNode("select", { id: uniqueId.value }, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(__props.data, (item) => {
            return openBlock(), createElementBlock("option", {
              val: item[unref(valueField)],
              key: item[unref(valueField)]
            }, toDisplayString(item[unref(labelField)]), 9, _hoisted_2$a);
          }), 128))
        ], 8, _hoisted_1$c),
        createElementVNode("div", _hoisted_3$9, [
          createElementVNode("div", _hoisted_4$9, [
            withDirectives(createElementVNode("input", {
              type: "search",
              placeholder: __props.placeholder ?? " ",
              readonly: typeof __props.filterable === "undefined" || __props.filterable === false || __props.disabled,
              onClick: toggleDropDown,
              class: normalizeClass({ disabled: __props.disabled }),
              onKeydown: onKeyDown,
              onKeyup: onKeyUp,
              autocomplete: "off",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => currentSelection.value = $event),
              "aria-label": __props.label
            }, null, 42, _hoisted_5$8), [
              [vModelText, currentSelection.value]
            ]),
            __props.label ? (openBlock(), createElementBlock("label", {
              key: 0,
              class: "select-label",
              for: uniqueId.value,
              onClick: toggleDropDown
            }, toDisplayString(__props.label), 9, _hoisted_6$6)) : createCommentVNode("", true),
            createElementVNode("a", {
              class: normalizeClass(["cla-icon-link cla-icon-link-drop", { "has-value": currentSelection.value !== "" }]),
              onClick: toggleDropDown
            }, null, 2),
            __props.tooltip ? (openBlock(), createBlock(Tooltip, {
              key: 1,
              content: __props.tooltip,
              "right-aligned": _ctx.tooltipRightAligned
            }, null, 8, ["content", "right-aligned"])) : createCommentVNode("", true)
          ]),
          createElementVNode("ul", {
            class: normalizeClass(["options-container", { open: unref(dropDownVisible) }])
          }, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(unref(visibleData), (item, index) => {
              return openBlock(), createElementBlock("li", {
                val: item[unref(valueField)],
                key: item[unref(valueField)],
                onClick: ($event) => selectItem(item),
                class: normalizeClass({ highlighted: index === unref(highlightedIndex) })
              }, toDisplayString(item[unref(labelField)]), 11, _hoisted_7$3);
            }), 128))
          ], 2)
        ]),
        createElementVNode("div", _hoisted_8$2, toDisplayString(__props.description), 1),
        createElementVNode("div", _hoisted_9$1, toDisplayString(_ctx.validationMessage), 1)
      ], 34);
    };
  }
};
const DropList = /* @__PURE__ */ _export_sfc(_sfc_main$d, [["__scopeId", "data-v-678acd4a"]]);
const TreeNode_vue_vue_type_style_index_0_scoped_b4c72884_lang = "";
const _sfc_main$c = {
  name: "TreeNode",
  props: [
    "data",
    "dataFnc",
    "value",
    "labels",
    "values",
    "expanded",
    "selected",
    "root",
    "leaf",
    "staticData",
    "selectedValue",
    "alwaysExpanded"
  ],
  data() {
    return {
      treeNodeData: this.data,
      labelField: this.labels || "name",
      valueField: this.values || "id",
      leafField: this.leaf || "isLeaf",
      isExpanded: this.expanded || false,
      isSelected: this.selected || false,
      treeRoot: this.root || this,
      hasChildren: this.data.children && this.data.children.length > 0,
      isLoading: false,
      eventHandlers: {},
      hasStaticData: this.staticData,
      treeSelectedValue: this.selectedValue || "",
      isAlwaysExpanded: this.alwaysExpanded
    };
  },
  mounted() {
    this.isExpanded = this.expanded || false;
    this.treeRoot.on("change", (e) => {
      if (this.isSelected && this.treeNodeData[this.valueField] !== e.value) {
        this.isSelected = false;
      } else {
        this.$emit("change", e);
      }
    });
  },
  methods: {
    on(event, callback) {
      if (!event || !callback)
        return;
      let subscribers = [];
      if (this.eventHandlers.hasOwnProperty(event)) {
        subscribers = this.eventHandlers[event];
      }
      subscribers.push(callback);
      this.eventHandlers[event] = subscribers;
    },
    emit(event, value) {
      if (!event)
        return;
      if (this.eventHandlers.hasOwnProperty(event)) {
        this.eventHandlers[event].map((handler) => handler(value));
      }
    },
    toggleExpand() {
      if (this.isLoading)
        return;
      this.isExpanded = !this.isExpanded;
      if (this.isExpanded && !this.treeNodeData.children && this.dataFnc) {
        this.isLoading = true;
        this.dataFnc(this.treeNodeData[this.valueField]).then((res) => {
          this.treeNodeData.children = res;
          this.hasChildren = res && res.length > 0;
          this.isLoading = false;
        }).catch((err) => {
          this.isLoading = false;
          console.error(err);
        });
      }
    },
    onSelect() {
      if (!this.isSelected) {
        this.isSelected = true;
        this.treeRoot.emit("change", {
          sender: this,
          value: this.treeNodeData[this.valueField],
          label: this.treeNodeData[this.labelField]
        });
      }
    },
    onDoubleClick() {
      if (!this.isSelected) {
        this.isSelected = true;
      }
      this.treeRoot.emit("dblclick", {
        sender: this,
        value: this.treeNodeData[this.valueField],
        label: this.treeNodeData[this.labelField]
      });
    }
  },
  watch: {
    data(val) {
      this.treeNodeData = val;
    },
    selected(val) {
      this.isSelected = val;
    },
    selectedValue(val) {
      this.isSelected = this.treeNodeData[this.valueField] === val;
      this.treeSelectedValue = val;
    }
  }
};
const _hoisted_1$b = { key: 0 };
function _sfc_render$6(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TreeNode = resolveComponent("TreeNode", true);
  return openBlock(), createElementBlock("li", {
    class: normalizeClass(["tree-node", { expanded: $data.isAlwaysExpanded || $data.isExpanded, selected: $data.isSelected }])
  }, [
    createElementVNode("div", null, [
      createElementVNode("div", {
        class: normalizeClass(["expander", { expanded: $data.isAlwaysExpanded || $data.treeNodeData.expanded, loading: $data.isLoading, hidden: $data.treeNodeData[$data.leafField] || $data.treeNodeData.children && $data.treeNodeData.children.length === 0 || $data.hasStaticData && !$data.treeNodeData.children }]),
        onClick: _cache[0] || (_cache[0] = (...args) => $options.toggleExpand && $options.toggleExpand(...args))
      }, null, 2),
      createElementVNode("div", {
        class: "label",
        onClick: _cache[1] || (_cache[1] = (...args) => $options.onSelect && $options.onSelect(...args)),
        onDblclick: _cache[2] || (_cache[2] = (...args) => $options.onDoubleClick && $options.onDoubleClick(...args))
      }, toDisplayString($data.treeNodeData[$data.labelField]), 33)
    ]),
    $data.hasChildren ? (openBlock(), createElementBlock("ul", _hoisted_1$b, [
      (openBlock(true), createElementBlock(Fragment, null, renderList($data.treeNodeData.children, (child) => {
        return openBlock(), createBlock(_component_TreeNode, {
          key: child[$data.valueField],
          data: child,
          labels: $data.labelField,
          values: $data.valueField,
          root: $data.treeRoot,
          dataFnc: $props.dataFnc,
          leaf: $data.leafField,
          "static-data": $data.hasStaticData,
          "selected-value": $data.treeSelectedValue,
          alwaysExpanded: $data.isAlwaysExpanded
        }, null, 8, ["data", "labels", "values", "root", "dataFnc", "leaf", "static-data", "selected-value", "alwaysExpanded"]);
      }), 128))
    ])) : createCommentVNode("", true)
  ], 2);
}
const TreeNode = /* @__PURE__ */ _export_sfc(_sfc_main$c, [["render", _sfc_render$6], ["__scopeId", "data-v-b4c72884"]]);
const DropTree_vue_vue_type_style_index_0_scoped_54668a2c_lang = "";
const _hoisted_1$a = { class: "control-container" };
const _hoisted_2$9 = { class: "input-container" };
const _hoisted_3$8 = ["placeholder", "readonly", "aria-label"];
const _hoisted_4$8 = ["for"];
const _hoisted_5$7 = { class: "description-container" };
const _hoisted_6$5 = { class: "validation-error" };
const _sfc_main$b = {
  __name: "DropTree",
  props: [
    "label",
    "mandatory",
    "filterable",
    "data",
    "modelValue",
    "labels",
    "values",
    "placeholder",
    "tooltip",
    "disabled",
    "invalid",
    "description",
    "validation-message",
    "custom-entry-label",
    "tooltip-right-aligned"
  ],
  emits: ["update:modelValue", "change", "custom", "dblclick"],
  setup(__props, { emit }) {
    const props = __props;
    const labelField = props.labels || "name";
    const valueField = props.values || "id";
    let dropDownVisible = ref(false);
    let visibleData = ref([]);
    const self = getCurrentInstance();
    const leafField = props.leaf || "isLeaf";
    const treeData = ref(props.data || []);
    const refDropTree = ref(null);
    const currentSelection = ref("");
    const currentValue = ref("");
    const uniqueId = computed({
      get() {
        return Utils.getComponentId(self == null ? void 0 : self.type.__name);
      }
    });
    watch(
      () => props.modelValue,
      () => {
        selectValue(props.modelValue);
        visibleData.value = Array.isArray(props.data) ? [...props.data] : [];
      }
    );
    onMounted(() => {
      treeData.value = props.data || [];
      visibleData.value = Array.isArray(props.data) ? [...props.data] : [];
      document.addEventListener("click", onClickOutside);
      document.addEventListener("touchstart", onClickOutside);
      messageBus.on("dropdown-displayed", (sender) => {
        if (sender !== self)
          dropDownVisible.value = false;
      });
      if (props.modelValue && props.data) {
        console.log("Setting default selection when mounted.");
        const val = props.modelValue;
        let entry = getItemByValue(props.data, val);
        if (entry) {
          currentSelection.value = entry[labelField];
          currentValue.value = entry[valueField];
        } else {
          currentSelection.value = "";
          currentValue.value = "";
        }
      }
    });
    onUnmounted(() => {
      document.removeEventListener("click", onClickOutside);
      document.removeEventListener("touchstart", onClickOutside);
    });
    function onDoubleClick(e) {
      emit("dblclick", { sender: this, value: e.value, label: e.label });
    }
    function toggleDropTree() {
      var _a, _b;
      if (props.disabled)
        return;
      dropDownVisible.value = !dropDownVisible.value;
      if (typeof props.filterable !== "undefined" && dropDownVisible.value) {
        (_b = (_a = refDropTree.value) == null ? void 0 : _a.querySelector("input[type='search']")) == null ? void 0 : _b.focus();
      }
      if (dropDownVisible.value) {
        messageBus.emit("dropdown-displayed", self);
      }
    }
    function selectValue(value) {
      if (!value || !props.data || props.data.length === 0) {
        currentSelection.value = "";
        currentValue.value = "";
        return;
      }
      let matchingItem = getItemByValue(props.data, value);
      if (matchingItem) {
        currentSelection.value = matchingItem[labelField];
        currentValue.value = matchingItem[valueField];
      }
    }
    function getItemByValue(data, value) {
      if (!data)
        return "";
      if (!Array.isArray(data))
        return "";
      for (let c of data) {
        if (c[valueField] === value) {
          return c;
        }
        const item = getItemByValue(c.children, value);
        if (item)
          return item;
      }
      return "";
    }
    function selectItem(e) {
      dropDownVisible.value = false;
      const value = e == null ? void 0 : e.value;
      const label = e == null ? void 0 : e.label;
      currentSelection.value = label;
      currentValue.value = value;
      emit("update:modelValue", value);
      emit("change", {
        sender: self.props,
        value,
        label
      });
    }
    function onBlur() {
      dropDownVisible.value = false;
    }
    function onClickOutside(e) {
      if (!refDropTree)
        return;
      if (!dropDownVisible.value)
        return;
      if (!refDropTree.value.contains(e.target)) {
        dropDownVisible.value = false;
      }
    }
    function onKeyDown(e) {
      if (typeof props.filterable !== "undefined" && props.filterable != "false") {
        if (e.keyCode === 27) {
          e.preventDefault();
          dropDownVisible.value = false;
        } else if (e.keyCode === 9) {
          dropDownVisible.value = false;
        } else {
          dropDownVisible.value = true;
        }
      }
    }
    function onKeyUp(e) {
      if (typeof props.filterable !== "undefined" && props.filterable != "false") {
        if (e.keyCode === 27) {
          e.preventDefault();
          dropDownVisible.value = false;
        } else if (isPrintable(e.keyCode) || e.keyCode === 46 || e.keyCode === 8) {
          treeData.value = filterHierarchy(props.data || [], currentSelection.value.toLowerCase());
        }
      }
    }
    function filterHierarchy(data, searchString) {
      function filterNodes(nodes) {
        return nodes.map((node) => {
          const { id, name, children } = node;
          const filteredChildren = children ? filterNodes(children) : [];
          if (name.toLowerCase().includes(searchString) || filteredChildren.length > 0) {
            return { id, name, children: filteredChildren };
          }
          return null;
        }).filter((node) => node !== null);
      }
      return filterNodes(data);
    }
    function isPrintable(keycode) {
      var valid = keycode > 47 && keycode < 58 || // number keys
      keycode == 32 || keycode == 13 || // spacebar & return key(s) (if you want to allow carriage returns)
      keycode > 64 && keycode < 91 || // letter keys
      keycode > 95 && keycode < 112 || // numpad keys
      keycode > 185 && keycode < 193 || // ;=,-./` (in order)
      keycode > 218 && keycode < 223;
      return valid;
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["cla-droptree-container vue-ctrl", {
          mandatory: typeof __props.mandatory !== "undefined" && __props.mandatory !== false,
          invalid: typeof __props.invalid !== "undefined" && __props.invalid !== false
        }]),
        onBlur,
        ref_key: "refDropTree",
        ref: refDropTree
      }, [
        createElementVNode("div", _hoisted_1$a, [
          createElementVNode("div", _hoisted_2$9, [
            withDirectives(createElementVNode("input", {
              type: "search",
              placeholder: __props.placeholder ?? " ",
              readonly: typeof __props.filterable === "undefined" || __props.filterable === false || __props.disabled,
              onClick: toggleDropTree,
              class: normalizeClass({ disabled: __props.disabled }),
              onKeydown: onKeyDown,
              onKeyup: onKeyUp,
              autocomplete: "off",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => currentSelection.value = $event),
              "aria-label": __props.label
            }, null, 42, _hoisted_3$8), [
              [vModelText, currentSelection.value]
            ]),
            __props.label ? (openBlock(), createElementBlock("label", {
              key: 0,
              class: "select-label",
              for: uniqueId.value,
              onClick: toggleDropTree
            }, toDisplayString(__props.label), 9, _hoisted_4$8)) : createCommentVNode("", true),
            createElementVNode("a", {
              class: normalizeClass(["cla-icon-link cla-icon-link-drop", { "has-value": currentSelection.value !== "" }]),
              onClick: toggleDropTree
            }, null, 2),
            __props.tooltip ? (openBlock(), createBlock(Tooltip, {
              key: 1,
              content: __props.tooltip,
              "right-aligned": _ctx.tooltipRightAligned
            }, null, 8, ["content", "right-aligned"])) : createCommentVNode("", true)
          ]),
          createElementVNode("ul", {
            class: normalizeClass(["options-container", { open: unref(dropDownVisible) }])
          }, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(treeData.value, (subtree) => {
              return openBlock(), createBlock(TreeNode, {
                data: subtree,
                labels: unref(labelField),
                values: unref(valueField),
                onChange: selectItem,
                "always-expanded": typeof __props.filterable !== "undefined" && __props.filterable != "false",
                onDblclick: onDoubleClick,
                leaf: unref(leafField),
                key: subtree[unref(valueField)],
                "static-data": true,
                "selected-value": currentValue.value
              }, null, 8, ["data", "labels", "values", "always-expanded", "leaf", "selected-value"]);
            }), 128))
          ], 2)
        ]),
        createElementVNode("div", _hoisted_5$7, toDisplayString(__props.description), 1),
        createElementVNode("div", _hoisted_6$5, toDisplayString(_ctx.validationMessage), 1)
      ], 34);
    };
  }
};
const DropTree = /* @__PURE__ */ _export_sfc(_sfc_main$b, [["__scopeId", "data-v-54668a2c"]]);
const FlatButton_vue_vue_type_style_index_0_scoped_2dbb34fe_lang = "";
const _sfc_main$a = {
  __name: "FlatButton",
  props: {
    label: String,
    gray: Boolean,
    blue: Boolean,
    white: Boolean,
    inlineLeft: Boolean,
    inlineRight: Boolean,
    disabled: Boolean
  },
  emits: ["click"],
  setup(__props, { emit }) {
    const props = __props;
    const self = getCurrentInstance();
    function onClick() {
      if (!props.disabled) {
        emit("click", { sender: self.props });
      }
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("button", {
        class: normalizeClass(["button vue-ctrl", { gray: __props.disabled || __props.gray, blue: __props.blue && !__props.disabled, white: __props.white, "inline-left": __props.inlineLeft, "inline-right": __props.inlineRight, disabled: __props.disabled }]),
        onClick
      }, toDisplayString(__props.label), 3);
    };
  }
};
const FlatButton = /* @__PURE__ */ _export_sfc(_sfc_main$a, [["__scopeId", "data-v-2dbb34fe"]]);
const TextBox_vue_vue_type_style_index_0_scoped_a077e90f_lang = "";
const _hoisted_1$9 = { class: "control-container" };
const _hoisted_2$8 = { class: "input-container" };
const _hoisted_3$7 = ["type", "placeholder", "onKeyup", "readonly", "maxlength", "id"];
const _hoisted_4$7 = ["for"];
const _hoisted_5$6 = { class: "description-container" };
const _hoisted_6$4 = { class: "validation-error" };
const _sfc_main$9 = {
  __name: "TextBox",
  props: [
    "label",
    "mandatory",
    "modelValue",
    "placeholder",
    "tooltip",
    "invalid",
    "readonly",
    "description",
    "validation-message",
    "maxlength",
    "password",
    "tooltip-right-aligned"
  ],
  emits: ["update:modelValue", "change"],
  setup(__props, { emit }) {
    const props = __props;
    const self = getCurrentInstance();
    const currentText = ref(props.value);
    const uniqueId = computed({
      get() {
        return Utils.getComponentId(self == null ? void 0 : self.type.__name);
      }
    });
    function onChange() {
      emit("update:modelValue", currentText.value);
      emit("change", currentText.value);
    }
    watchEffect(() => {
      currentText.value = props.modelValue;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["cla-textbox-container vue-ctrl", { mandatory: typeof __props.mandatory !== "undefined" && __props.mandatory !== false, invalid: typeof __props.invalid !== "undefined" && __props.invalid !== false }])
      }, [
        createElementVNode("div", _hoisted_1$9, [
          createElementVNode("div", _hoisted_2$8, [
            withDirectives(createElementVNode("input", {
              type: typeof __props.password !== "undefined" && __props.password !== false ? "password" : "text",
              placeholder: __props.placeholder ?? " ",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => currentText.value = $event),
              onChange,
              onKeyup: withKeys(onChange, ["enter"]),
              readonly: typeof __props.readonly !== "undefined" && __props.readonly !== false,
              maxlength: __props.maxlength,
              id: uniqueId.value
            }, null, 40, _hoisted_3$7), [
              [vModelDynamic, currentText.value]
            ]),
            __props.label ? (openBlock(), createElementBlock("label", {
              key: 0,
              for: uniqueId.value,
              class: "textbox-label"
            }, toDisplayString(__props.label), 9, _hoisted_4$7)) : createCommentVNode("", true),
            __props.tooltip ? (openBlock(), createBlock(Tooltip, {
              key: 1,
              content: __props.tooltip,
              "right-aligned": _ctx.tooltipRightAligned
            }, null, 8, ["content", "right-aligned"])) : createCommentVNode("", true)
          ])
        ]),
        createElementVNode("div", _hoisted_5$6, toDisplayString(__props.description), 1),
        createElementVNode("div", _hoisted_6$4, toDisplayString(_ctx.validationMessage), 1)
      ], 2);
    };
  }
};
const TextBox = /* @__PURE__ */ _export_sfc(_sfc_main$9, [["__scopeId", "data-v-a077e90f"]]);
const NoteBox_vue_vue_type_style_index_0_scoped_b477e60f_lang = "";
const _hoisted_1$8 = { class: "control-container" };
const _hoisted_2$7 = { class: "input-container" };
const _hoisted_3$6 = ["placeholder", "rows", "maxlength", "id"];
const _hoisted_4$6 = ["for"];
const _hoisted_5$5 = { class: "description-container" };
const _hoisted_6$3 = { class: "validation-error" };
const _sfc_main$8 = {
  __name: "NoteBox",
  props: [
    "label",
    "mandatory",
    "modelValue",
    "placeholder",
    "tooltip",
    "rows",
    "invalid",
    "description",
    "validation-message",
    "maxlength"
  ],
  emits: ["update:modelValue", "change"],
  setup(__props, { emit }) {
    const props = __props;
    const self = getCurrentInstance();
    const currentText = ref(props.modelValue);
    const uniqueId = computed({
      get() {
        return Utils.getComponentId(self == null ? void 0 : self.type.__name);
      }
    });
    function onChange() {
      emit("update:modelValue", currentText.value);
      emit("change", currentText.value);
    }
    watchEffect(() => {
      currentText.value = props.modelValue;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["cla-notebox-container vue-ctrl", { mandatory: typeof __props.mandatory !== "undefined" && __props.mandatory !== false, invalid: typeof __props.invalid !== "undefined" && __props.invalid !== false }])
      }, [
        createElementVNode("div", _hoisted_1$8, [
          createElementVNode("div", _hoisted_2$7, [
            withDirectives(createElementVNode("textarea", {
              placeholder: __props.placeholder ?? " ",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => currentText.value = $event),
              rows: __props.rows,
              onChange,
              maxlength: __props.maxlength,
              id: uniqueId.value
            }, null, 40, _hoisted_3$6), [
              [vModelText, currentText.value]
            ]),
            __props.label ? (openBlock(), createElementBlock("label", {
              key: 0,
              for: uniqueId.value,
              class: "notebox-label"
            }, toDisplayString(__props.label), 9, _hoisted_4$6)) : createCommentVNode("", true)
          ])
        ]),
        createElementVNode("div", _hoisted_5$5, [
          createTextVNode(toDisplayString(__props.description), 1),
          __props.tooltip ? (openBlock(), createBlock(Tooltip, {
            key: 0,
            content: __props.tooltip,
            class: "small"
          }, null, 8, ["content"])) : createCommentVNode("", true)
        ]),
        createElementVNode("div", _hoisted_6$3, toDisplayString(_ctx.validationMessage), 1)
      ], 2);
    };
  }
};
const NoteBox = /* @__PURE__ */ _export_sfc(_sfc_main$8, [["__scopeId", "data-v-b477e60f"]]);
const FilePicker_vue_vue_type_style_index_0_scoped_1ad0a1e9_lang = "";
const _sfc_main$7 = {
  name: "FilePicker",
  props: [
    "label",
    "mandatory",
    "placeholder",
    "browseLabel",
    "tooltip",
    "invalid",
    "description",
    "validation-message"
  ],
  components: { Tooltip },
  data() {
    return {
      currentText: "",
      browse: this.browseLabel || "Browse"
    };
  },
  computed: {
    uniqueId() {
      return Utils.getComponentId(this);
    }
  },
  methods: {
    onChange() {
      let fullpath = this.$refs.fileInput.value;
      if (fullpath) {
        var startIndex = fullpath.indexOf("\\") >= 0 ? fullpath.lastIndexOf("\\") : fullpath.lastIndexOf("/");
        var filename = fullpath.substring(startIndex);
        if (filename.indexOf("\\") === 0 || filename.indexOf("/") === 0) {
          filename = filename.substring(1);
        }
        this.currentText = filename;
        this.$emit("input", this.currentText);
        this.$emit("change", { fileName: this.currentText, sender: this.$refs.fileInput });
      }
    },
    onBrowse() {
      this.$refs.fileInput.click();
    },
    getFileInput() {
      return this.$refs.fileInput;
    }
  }
};
const _withScopeId = (n) => (pushScopeId("data-v-1ad0a1e9"), n = n(), popScopeId(), n);
const _hoisted_1$7 = { class: "control-container" };
const _hoisted_2$6 = { class: "input-container" };
const _hoisted_3$5 = ["id"];
const _hoisted_4$5 = ["placeholder", "value"];
const _hoisted_5$4 = ["for"];
const _hoisted_6$2 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("div", { class: "vertical-separator" }, null, -1));
const _hoisted_7$2 = { class: "description-container" };
const _hoisted_8$1 = { class: "validation-error" };
function _sfc_render$5(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Tooltip = resolveComponent("Tooltip");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["cla-filepicker-container vue-ctrl", { mandatory: typeof $props.mandatory !== "undefined" && $props.mandatory !== false, invalid: typeof $props.invalid !== "undefined" && $props.invalid !== false }])
  }, [
    createElementVNode("div", _hoisted_1$7, [
      createElementVNode("div", _hoisted_2$6, [
        createElementVNode("input", {
          type: "file",
          ref: "fileInput",
          onChange: _cache[0] || (_cache[0] = (...args) => $options.onChange && $options.onChange(...args)),
          id: $options.uniqueId
        }, null, 40, _hoisted_3$5),
        createElementVNode("input", {
          type: "text",
          placeholder: $props.placeholder || " ",
          readonly: "",
          value: $data.currentText
        }, null, 8, _hoisted_4$5),
        $props.label ? (openBlock(), createElementBlock("label", {
          key: 0,
          for: $options.uniqueId,
          class: "filepicker-label"
        }, toDisplayString($props.label), 9, _hoisted_5$4)) : createCommentVNode("", true),
        _hoisted_6$2,
        createElementVNode("a", {
          class: "browse-link",
          onClick: _cache[1] || (_cache[1] = (...args) => $options.onBrowse && $options.onBrowse(...args))
        }, toDisplayString($data.browse), 1)
      ])
    ]),
    createElementVNode("div", _hoisted_7$2, [
      createTextVNode(toDisplayString($props.description), 1),
      $props.tooltip ? (openBlock(), createBlock(_component_Tooltip, {
        key: 0,
        content: $props.tooltip,
        class: "small"
      }, null, 8, ["content"])) : createCommentVNode("", true)
    ]),
    createElementVNode("div", _hoisted_8$1, toDisplayString(_ctx.validationMessage), 1)
  ], 2);
}
const FilePicker = /* @__PURE__ */ _export_sfc(_sfc_main$7, [["render", _sfc_render$5], ["__scopeId", "data-v-1ad0a1e9"]]);
const TreeList_vue_vue_type_style_index_0_scoped_0f58fc26_lang = "";
const _sfc_main$6 = {
  name: "TreeList",
  props: [
    "label",
    "mandatory",
    "data",
    "dataFnc",
    "value",
    "labels",
    "leaf",
    "values",
    "height",
    "tooltip",
    "description",
    "validation-message"
  ],
  components: {
    TreeNode,
    Tooltip
  },
  data() {
    return {
      labelField: this.labels || "name",
      valueField: this.values || "id",
      leafField: this.leaf || "isLeaf",
      selectedValue: this.value,
      treeData: this.data || {},
      controlHeight: this.height || "400px",
      treelist: this
    };
  },
  mounted() {
    if (!this.data && !this.dataFnc) {
      console.error(`The tree list with label ${this.label} is misconfigured`);
    }
  },
  methods: {
    onSelectionChange(e) {
      this.$emit("input", e.value);
      this.$emit("change", { sender: this, value: e.value, label: e.label });
    },
    onDoubleClick(e) {
      this.$emit("dblclick", { sender: this, value: e.value, label: e.label });
    }
  },
  watch: {
    value(val) {
      this.currentText = val;
    }
  }
};
const _hoisted_1$6 = { class: "label-container" };
const _hoisted_2$5 = {
  key: 0,
  class: "tree-label"
};
const _hoisted_3$4 = { class: "description-container" };
const _hoisted_4$4 = { class: "validation-error" };
function _sfc_render$4(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Tooltip = resolveComponent("Tooltip");
  const _component_TreeNode = resolveComponent("TreeNode");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["cla-tree-container vue-ctrl", { mandatory: typeof $props.mandatory !== "undefined" && $props.mandatory !== false }])
  }, [
    createElementVNode("div", _hoisted_1$6, [
      $props.label ? (openBlock(), createElementBlock("div", _hoisted_2$5, toDisplayString($props.label), 1)) : createCommentVNode("", true),
      $props.tooltip ? (openBlock(), createBlock(_component_Tooltip, {
        key: 1,
        content: $props.tooltip
      }, null, 8, ["content"])) : createCommentVNode("", true)
    ]),
    createElementVNode("ul", {
      class: "control-container",
      style: normalizeStyle("height:" + $data.controlHeight)
    }, [
      createVNode(_component_TreeNode, {
        data: $data.treeData,
        dataFnc: $props.dataFnc,
        labels: $data.labelField,
        values: $data.valueField,
        onChange: $options.onSelectionChange,
        onDblclick: $options.onDoubleClick,
        leaf: $data.leafField
      }, null, 8, ["data", "dataFnc", "labels", "values", "onChange", "onDblclick", "leaf"])
    ], 4),
    createElementVNode("div", _hoisted_3$4, toDisplayString($props.description), 1),
    createElementVNode("div", _hoisted_4$4, toDisplayString(_ctx.validationMessage), 1)
  ], 2);
}
const TreeList = /* @__PURE__ */ _export_sfc(_sfc_main$6, [["render", _sfc_render$4], ["__scopeId", "data-v-0f58fc26"]]);
const TagListItem_vue_vue_type_style_index_0_scoped_4016f2ed_lang = "";
const _sfc_main$5 = {
  name: "TagListItem",
  props: ["tag", "readonly"],
  data() {
    return {};
  },
  mounted() {
  },
  methods: {
    onRemove() {
      this.$emit("remove", this.$props.tag);
    }
  }
};
const _hoisted_1$5 = { class: "tag" };
const _hoisted_2$4 = { class: "tag-name" };
function _sfc_render$3(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("li", _hoisted_1$5, [
    createElementVNode("div", _hoisted_2$4, toDisplayString($props.tag.name), 1),
    typeof $props.readonly === "undefined" ? (openBlock(), createElementBlock("a", {
      key: 0,
      class: "tag-remove",
      onClick: _cache[0] || (_cache[0] = (...args) => $options.onRemove && $options.onRemove(...args))
    })) : createCommentVNode("", true)
  ]);
}
const TagListItem = /* @__PURE__ */ _export_sfc(_sfc_main$5, [["render", _sfc_render$3], ["__scopeId", "data-v-4016f2ed"]]);
const TagList_vue_vue_type_style_index_0_scoped_53f52af1_lang = "";
const _sfc_main$4 = {
  name: "TagList",
  props: [
    "label",
    "mandatory",
    "height",
    "tooltip",
    "tags",
    "readonly",
    "placeholder",
    "description",
    "validation-message"
  ],
  components: {
    TagListItem,
    Tooltip
  },
  data() {
    return {
      tagData: this.$props.tags || [],
      controlHeight: this.height || "auto"
    };
  },
  mounted() {
  },
  methods: {
    onRemoveTag(tag) {
      if (!tag)
        return;
      this.$emit("remove", tag);
    }
  },
  watch: {
    tags(val) {
      this.tagData = val;
    }
  }
};
const _hoisted_1$4 = { class: "label-container" };
const _hoisted_2$3 = {
  key: 0,
  class: "taglist-label"
};
const _hoisted_3$3 = {
  key: 0,
  class: "placeholder"
};
const _hoisted_4$3 = { class: "description-container" };
const _hoisted_5$3 = { class: "validation-error" };
function _sfc_render$2(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Tooltip = resolveComponent("Tooltip");
  const _component_TagListItem = resolveComponent("TagListItem");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["cla-taglist-container vue-ctrl", { mandatory: typeof $props.mandatory !== "undefined" && $props.mandatory !== false }])
  }, [
    createElementVNode("div", _hoisted_1$4, [
      $props.label ? (openBlock(), createElementBlock("div", _hoisted_2$3, toDisplayString($props.label), 1)) : createCommentVNode("", true),
      $props.tooltip ? (openBlock(), createBlock(_component_Tooltip, {
        key: 1,
        content: $props.tooltip
      }, null, 8, ["content"])) : createCommentVNode("", true)
    ]),
    createElementVNode("div", {
      class: "control-container",
      style: normalizeStyle("height:" + $data.controlHeight)
    }, [
      createElementVNode("ul", null, [
        (openBlock(true), createElementBlock(Fragment, null, renderList($data.tagData, (tag) => {
          return openBlock(), createBlock(_component_TagListItem, {
            key: tag.id,
            tag,
            readonly: $props.readonly,
            onRemove: $options.onRemoveTag
          }, null, 8, ["tag", "readonly", "onRemove"]);
        }), 128))
      ]),
      !$data.tagData || $data.tagData.length === 0 ? (openBlock(), createElementBlock("div", _hoisted_3$3, toDisplayString($props.placeholder), 1)) : createCommentVNode("", true)
    ], 4),
    createElementVNode("div", _hoisted_4$3, toDisplayString($props.description), 1),
    createElementVNode("div", _hoisted_5$3, toDisplayString(_ctx.validationMessage), 1)
  ], 2);
}
const TagList = /* @__PURE__ */ _export_sfc(_sfc_main$4, [["render", _sfc_render$2], ["__scopeId", "data-v-53f52af1"]]);
const ListBoxItem_vue_vue_type_style_index_0_scoped_6e78bfed_lang = "";
const _sfc_main$3 = {
  name: "ListBoxItem",
  props: ["item", "readonly", "uppercase"],
  data() {
    return {};
  },
  mounted() {
  },
  methods: {
    onRemove() {
      this.$emit("remove", this.$props.item);
    }
  }
};
const _hoisted_1$3 = { class: "list-item" };
function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("li", _hoisted_1$3, [
    createElementVNode("div", {
      class: normalizeClass(["list-item-name", { uppercase: typeof $props.uppercase !== "undefined" }])
    }, toDisplayString($props.item.name), 3),
    typeof $props.readonly === "undefined" ? (openBlock(), createElementBlock("a", {
      key: 0,
      class: "list-item-remove",
      onClick: _cache[0] || (_cache[0] = (...args) => $options.onRemove && $options.onRemove(...args))
    })) : createCommentVNode("", true)
  ]);
}
const ListBoxItem = /* @__PURE__ */ _export_sfc(_sfc_main$3, [["render", _sfc_render$1], ["__scopeId", "data-v-6e78bfed"]]);
const ListBox_vue_vue_type_style_index_0_scoped_d4589ac5_lang = "";
const _sfc_main$2 = {
  name: "ListBox",
  props: [
    "label",
    "mandatory",
    "height",
    "tooltip",
    "data",
    "readonly",
    "uppercase",
    "placeholder",
    "description",
    "validation-message",
    "invalid"
  ],
  components: {
    ListBoxItem,
    Tooltip
  },
  data() {
    return {
      listData: this.$props.data || [],
      controlHeight: this.height || "auto"
    };
  },
  mounted() {
  },
  methods: {
    onRemoveItem(item) {
      if (!item)
        return;
      this.$emit("remove", { sender: this, item });
    }
  },
  watch: {
    data(val) {
      this.listData = val;
    }
  }
};
const _hoisted_1$2 = { class: "label-container" };
const _hoisted_2$2 = {
  key: 0,
  class: "list-label"
};
const _hoisted_3$2 = {
  key: 0,
  class: "placeholder"
};
const _hoisted_4$2 = { class: "description-container" };
const _hoisted_5$2 = { class: "validation-error" };
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Tooltip = resolveComponent("Tooltip");
  const _component_ListBoxItem = resolveComponent("ListBoxItem");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["cla-list-container vue-ctrl", { mandatory: typeof $props.mandatory !== "undefined" && $props.mandatory !== false }])
  }, [
    createElementVNode("div", _hoisted_1$2, [
      $props.label ? (openBlock(), createElementBlock("div", _hoisted_2$2, toDisplayString($props.label), 1)) : createCommentVNode("", true),
      $props.tooltip ? (openBlock(), createBlock(_component_Tooltip, {
        key: 1,
        content: $props.tooltip
      }, null, 8, ["content"])) : createCommentVNode("", true)
    ]),
    createElementVNode("div", {
      class: "control-container",
      style: normalizeStyle("height:" + $data.controlHeight)
    }, [
      createElementVNode("ul", null, [
        (openBlock(true), createElementBlock(Fragment, null, renderList($data.listData, (li) => {
          return openBlock(), createBlock(_component_ListBoxItem, {
            key: li.id,
            item: li,
            readonly: $props.readonly,
            uppercase: $props.uppercase,
            onRemove: $options.onRemoveItem
          }, null, 8, ["item", "readonly", "uppercase", "onRemove"]);
        }), 128))
      ]),
      !$data.listData || $data.listData.length === 0 ? (openBlock(), createElementBlock("div", _hoisted_3$2, toDisplayString($props.placeholder), 1)) : createCommentVNode("", true)
    ], 4),
    createElementVNode("div", _hoisted_4$2, toDisplayString($props.description), 1),
    createElementVNode("div", _hoisted_5$2, toDisplayString(_ctx.validationMessage), 1)
  ], 2);
}
const ListBox = /* @__PURE__ */ _export_sfc(_sfc_main$2, [["render", _sfc_render], ["__scopeId", "data-v-d4589ac5"]]);
const ModalSelector_vue_vue_type_style_index_0_scoped_f40105d0_lang = "";
const _hoisted_1$1 = { class: "control-container" };
const _hoisted_2$1 = { class: "input-container" };
const _hoisted_3$1 = ["id", "placeholder", "aria-label"];
const _hoisted_4$1 = ["for"];
const _hoisted_5$1 = { class: "description-container" };
const _hoisted_6$1 = { class: "validation-error" };
const _hoisted_7$1 = { class: "modal-title" };
const _hoisted_8 = { class: "options-container" };
const _hoisted_9 = ["val", "onClick"];
const _sfc_main$1 = {
  __name: "ModalSelector",
  props: [
    "label",
    "mandatory",
    "data",
    "modelValue",
    "labels",
    "values",
    "placeholder",
    "tooltip",
    "disabled",
    "invalid",
    "description",
    "validation-message",
    "custom-entry-label",
    "tooltip-right-aligned",
    "columns"
  ],
  emits: ["update:modelValue", "change"],
  setup(__props, { emit }) {
    const props = __props;
    const labelField = props.labels || "name";
    const valueField = props.values || "id";
    let highlightedIndex = ref(-1);
    let visibleData = ref([]);
    let modalVisible = ref(false);
    const currentSelection = ref("");
    const self = getCurrentInstance();
    const uniqueId = computed({
      get() {
        return Utils.getComponentId(self == null ? void 0 : self.type.__name);
      }
    });
    watchEffect(() => {
      selectValue(props.modelValue);
      visibleData.value = Array.isArray(props.data) ? [...props.data] : [];
    });
    onMounted(() => {
      visibleData.value = Array.isArray(props.data) ? [...props.data] : [];
      if (props.modelValue && props.data) {
        console.log("Setting default modal selector selection when mounted.");
        const val = props.modelValue;
        let entry = props.data.find((i) => {
          return i[valueField] === val;
        });
        if (entry) {
          currentSelection.value = entry[labelField];
        } else {
          currentSelection.value = "";
        }
      }
    });
    onUnmounted(() => {
    });
    let removeScrollBlock = false;
    const showModal = (show) => {
      if (typeof props.disabled !== "undefined" && props.disabled !== false)
        return;
      if (show) {
        removeScrollBlock = !document.body.classList.contains("noscroll");
        window.preventScroll(show);
      } else {
        if (removeScrollBlock)
          window.preventScroll(false);
      }
      if (show && currentSelection.value) {
        highlightedIndex.value = props.data.findIndex((x) => x[labelField] === currentSelection.value);
      }
      modalVisible.value = show;
    };
    function selectValue(value) {
      if (!value || !props.data || props.data.length === 0) {
        currentSelection.value = "";
        return;
      }
      let matchingItems = props.data.filter((x) => x[valueField] === value);
      if (matchingItems && matchingItems.length > 0) {
        currentSelection.value = matchingItems[0][labelField];
      }
    }
    function selectItem(item) {
      showModal(false);
      const value = item ? item[valueField] : "";
      const label = item ? item[labelField] : "";
      currentSelection.value = label;
      emit("update:modelValue", value);
      emit("change", {
        sender: self.props,
        value,
        label
      });
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["cla-modalselector-container vue-ctrl", {
          mandatory: typeof __props.mandatory !== "undefined" && __props.mandatory !== false,
          invalid: typeof __props.invalid !== "undefined" && __props.invalid !== false
        }]),
        ref: "refSelector"
      }, [
        createElementVNode("div", _hoisted_1$1, [
          createElementVNode("div", _hoisted_2$1, [
            withDirectives(createElementVNode("input", {
              id: uniqueId.value,
              type: "text",
              placeholder: __props.placeholder ?? " ",
              readonly: true,
              class: normalizeClass({ disabled: typeof __props.disabled !== "undefined" && __props.disabled !== false }),
              autocomplete: "off",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => currentSelection.value = $event),
              "aria-label": __props.label,
              onClick: _cache[1] || (_cache[1] = ($event) => showModal(true))
            }, null, 10, _hoisted_3$1), [
              [vModelText, currentSelection.value]
            ]),
            __props.label ? (openBlock(), createElementBlock("label", {
              key: 0,
              class: "selector-label",
              for: uniqueId.value,
              onClick: showModal
            }, toDisplayString(__props.label), 9, _hoisted_4$1)) : createCommentVNode("", true),
            createElementVNode("a", {
              class: normalizeClass(["cla-icon-link cla-icon-dots", { "has-value": currentSelection.value !== "" }]),
              onClick: _cache[2] || (_cache[2] = ($event) => showModal(true))
            }, null, 2),
            __props.tooltip ? (openBlock(), createBlock(Tooltip, {
              key: 1,
              content: __props.tooltip,
              "right-aligned": _ctx.tooltipRightAligned
            }, null, 8, ["content", "right-aligned"])) : createCommentVNode("", true)
          ])
        ]),
        createElementVNode("div", _hoisted_5$1, toDisplayString(__props.description), 1),
        createElementVNode("div", _hoisted_6$1, toDisplayString(_ctx.validationMessage), 1),
        createElementVNode("div", {
          class: normalizeClass(["modal-container", { visible: unref(modalVisible) }])
        }, [
          createElementVNode("div", {
            class: normalizeClass(["modal-dialog", `columns-${__props.columns || 1}`])
          }, [
            createElementVNode("a", {
              role: "button",
              class: "modal-close",
              onClick: _cache[3] || (_cache[3] = ($event) => showModal(false))
            }),
            createElementVNode("div", _hoisted_7$1, toDisplayString(__props.label), 1),
            createElementVNode("ul", _hoisted_8, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(unref(visibleData), (item, index) => {
                return openBlock(), createElementBlock("li", {
                  val: item[unref(valueField)],
                  key: item[unref(valueField)],
                  onClick: ($event) => selectItem(item),
                  class: normalizeClass({ highlighted: index === unref(highlightedIndex) })
                }, toDisplayString(item[unref(labelField)]), 11, _hoisted_9);
              }), 128))
            ])
          ], 2)
        ], 2)
      ], 2);
    };
  }
};
const ModalSelector = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["__scopeId", "data-v-f40105d0"]]);
const AutocompleteTextBox_vue_vue_type_style_index_0_scoped_109009d1_lang = "";
const _hoisted_1 = { class: "control-container" };
const _hoisted_2 = { class: "input-container" };
const _hoisted_3 = ["placeholder", "readonly", "aria-label"];
const _hoisted_4 = ["for"];
const _hoisted_5 = ["onClick"];
const _hoisted_6 = { class: "description-container" };
const _hoisted_7 = { class: "validation-error" };
const _sfc_main = {
  __name: "AutocompleteTextBox",
  props: [
    "label",
    "mandatory",
    "data",
    "modelValue",
    "placeholder",
    "tooltip",
    "disabled",
    "invalid",
    "description",
    "validation-message",
    "custom-entry-label",
    "tooltip-right-aligned"
  ],
  emits: ["update:modelValue", "change", "custom"],
  setup(__props, { emit }) {
    const props = __props;
    props.labels || "name";
    props.values || "id";
    const dropDownVisible = ref(false);
    const highlightedIndex = ref(-1);
    let visibleData = ref([]);
    const self = getCurrentInstance();
    const refAutocomplete = ref(null);
    const currentText = ref("");
    const inputBox = ref(null);
    const uniqueId = computed({
      get() {
        return Utils.getComponentId(self == null ? void 0 : self.type.__name);
      }
    });
    onMounted(() => {
      visibleData.value = Array.isArray(props.data) ? [...props.data] : [];
      document.addEventListener("click", onClickOutside);
      document.addEventListener("touchstart", onClickOutside);
      messageBus.on("dropdown-displayed", (sender) => {
        if (sender !== self)
          dropDownVisible.value = false;
      });
      if (props.modelValue && props.data) {
        console.log("Setting default selection when mounted.");
        const val = props.modelValue;
        let entry = props.data.find((i) => {
          return i === val;
        });
        if (entry) {
          currentText.value = entry;
        } else {
          currentText.value = "";
        }
      }
    });
    onUnmounted(() => {
      document.removeEventListener("click", onClickOutside);
      document.removeEventListener("touchstart", onClickOutside);
    });
    function selectItem(item) {
      dropDownVisible.value = false;
      currentText.value = item;
      emit("update:modelValue", item);
      emit("change", item);
    }
    function onBlur() {
      dropDownVisible.value = false;
    }
    function onClickOutside(e) {
      if (!refAutocomplete)
        return;
      if (!dropDownVisible.value)
        return;
      if (!refAutocomplete.value.contains(e.target)) {
        dropDownVisible.value = false;
      }
    }
    function onKeyUp(e) {
      refAutocomplete.value.querySelector(".options-container");
      const container = refAutocomplete.value;
      if (e.keyCode === 40) {
        e.preventDefault();
        if (!dropDownVisible.value) {
          dropDownVisible.value = true;
          messageBus.emit("dropdown-displayed", self);
          highlightedIndex.value = visibleData.value.findIndex((x) => x === currentText.value);
        } else {
          if (highlightedIndex.value < visibleData.value.length - 1)
            highlightedIndex.value++;
        }
      } else if (e.keyCode === 38) {
        e.preventDefault();
        if (highlightedIndex.value > 0)
          highlightedIndex.value--;
      } else if (e.keyCode === 13) {
        e.preventDefault();
        if (highlightedIndex.value > -1 && highlightedIndex.value < visibleData.value.length) {
          selectItem(visibleData.value[highlightedIndex.value]);
          filterDropDownOptions();
        }
        container.focus();
      } else if (e.keyCode === 27) {
        e.preventDefault();
        dropDownVisible.value = false;
      } else if (isPrintable(e.keyCode) || e.keyCode === 46 || e.keyCode === 8) {
        filterDropDownOptions();
        dropDownVisible.value = visibleData.value.length > 0;
      }
    }
    function filterDropDownOptions() {
      let ss = currentText.value.toLowerCase();
      visibleData.value = [];
      props.data.map((e) => {
        if (e.toLowerCase().indexOf(ss) === 0) {
          visibleData.value.push(e);
        }
      });
      highlightedIndex.value = -1;
    }
    function isPrintable(keycode) {
      var valid = keycode > 47 && keycode < 58 || // number keys
      keycode == 32 || keycode == 13 || // spacebar & return key(s) (if you want to allow carriage returns)
      keycode > 64 && keycode < 91 || // letter keys
      keycode > 95 && keycode < 112 || // numpad keys
      keycode > 185 && keycode < 193 || // ;=,-./` (in order)
      keycode > 218 && keycode < 223;
      return valid;
    }
    function onChange() {
      console.log("On Change");
      emit("update:modelValue", currentText.value);
      emit("change", currentText.value);
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["cla-autocomplete-container vue-ctrl", {
          mandatory: typeof __props.mandatory !== "undefined" && __props.mandatory !== false,
          invalid: typeof __props.invalid !== "undefined" && __props.invalid !== false
        }]),
        onBlur,
        ref_key: "refAutocomplete",
        ref: refAutocomplete
      }, [
        createElementVNode("div", _hoisted_1, [
          createElementVNode("div", _hoisted_2, [
            withDirectives(createElementVNode("input", {
              type: "search",
              placeholder: __props.placeholder ?? " ",
              readonly: __props.disabled,
              class: normalizeClass({ disabled: __props.disabled }),
              onKeyup: onKeyUp,
              autocomplete: "off",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => currentText.value = $event),
              "aria-label": __props.label,
              ref_key: "inputBox",
              ref: inputBox,
              onChange,
              onBlur
            }, null, 42, _hoisted_3), [
              [vModelText, currentText.value]
            ]),
            __props.label ? (openBlock(), createElementBlock("label", {
              key: 0,
              class: "autocomplete-label",
              for: uniqueId.value,
              onClick: _cache[1] || (_cache[1] = ($event) => inputBox.value.focus())
            }, toDisplayString(__props.label), 9, _hoisted_4)) : createCommentVNode("", true),
            __props.tooltip ? (openBlock(), createBlock(Tooltip, {
              key: 1,
              content: __props.tooltip,
              "right-aligned": _ctx.tooltipRightAligned
            }, null, 8, ["content", "right-aligned"])) : createCommentVNode("", true)
          ]),
          createElementVNode("ul", {
            class: normalizeClass(["options-container", { open: dropDownVisible.value }])
          }, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(unref(visibleData), (item, index) => {
              return openBlock(), createElementBlock("li", {
                key: item,
                onClick: ($event) => selectItem(item),
                class: normalizeClass({ highlighted: index === highlightedIndex.value })
              }, toDisplayString(item), 11, _hoisted_5);
            }), 128))
          ], 2)
        ]),
        createElementVNode("div", _hoisted_6, toDisplayString(__props.description), 1),
        createElementVNode("div", _hoisted_7, toDisplayString(_ctx.validationMessage), 1)
      ], 34);
    };
  }
};
const AutocompleteTextBox = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-109009d1"]]);
const Components = {
  CheckboxGroup,
  Checkbox,
  RadioButtonGroup,
  RadioButton,
  DropList,
  DropTree,
  FlatButton,
  TextBox,
  NoteBox,
  FilePicker,
  TreeList,
  Tooltip,
  TagList,
  ListBox,
  ModalSelector,
  AutocompleteTextBox
};
export {
  AutocompleteTextBox,
  Checkbox,
  CheckboxGroup,
  DropList,
  DropTree,
  FilePicker,
  FlatButton,
  ListBox,
  ModalSelector,
  NoteBox,
  RadioButton,
  RadioButtonGroup,
  TagList,
  TextBox,
  Tooltip,
  TreeList,
  Components as default
};
